import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { DataSourceFields } from 'interfaces/api/dataSourceFields.interfaces'
import { axios } from 'modules/axios'
import { dataSourceFieldsMapper } from 'utils/dataSourceFieldsMapper'

const getAll = async (): GetArrayResponse<string> => {
  const { data: response } = await axios.request<DataSourceFields[]>({
    method: 'GET',
    url: endpoints.dataSourceFields.getAll(),
  })

  return dataSourceFieldsMapper(response)
}

export const dataSourceFieldsApi = {
  getAll,
}
